import React from "react";
import { money } from "../../utils/helpers";
import NotepadIcon from "assets/icon/NotepadIcon";

const CARD_META = [
    { key: "totalRevenue", growthKey: "totalRevenueGrowthPercent", label: "Total Omzet", accent: "emerald" },
    { key: "retailSales", growthKey: "retailSalesGrowthPercent", label: "Penjualan", accent: "blue" },
    { key: "racketRental", growthKey: "racketRentalGrowthPercent", label: "Rental", accent: "amber" },
    { key: "averageTransaction", growthKey: "averageTransactionGrowthPercent", label: "Average Transaction", accent: "pink" },
];

const ACCENT_CLASSES = {
    emerald: {
        card: "bg-emerald-50 border-emerald-100",
        icon: "bg-emerald-100 text-emerald-600",
    },
    blue: {
        card: "bg-blue-50 border-blue-100",
        icon: "bg-blue-100 text-blue-600",
    },
    amber: {
        card: "bg-amber-50 border-amber-100",
        icon: "bg-amber-100 text-amber-600",
    },
    violet: {
        card: "bg-violet-50 border-violet-100",
        icon: "bg-violet-100 text-violet-600",
    },
    cyan: {
        card: "bg-cyan-50 border-cyan-100",
        icon: "bg-cyan-100 text-cyan-600",
    },
    pink: {
        card: "bg-pink-50 border-pink-100",
        icon: "bg-pink-100 text-pink-600",
    },
};

export default function SummaryCards({ data, loading, error }) {
    if (error) {
        return (
            <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-600">
                {error}
            </div>
        );
    }

    return (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
            {CARD_META.map((card) => {

                const value = data?.[card.key];
                const growth = data?.[card.growthKey];
                const isPositive = growth == null || growth >= 0;

                return (
                    <div
                        key={card.key}
                        className={`flex gap-1 rounded-xl border p-4 shadow-sm transition-all hover:shadow-md ${ACCENT_CLASSES[card.accent].card}`}

                    >
                        <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${ACCENT_CLASSES[card.accent].icon}`}>
                            <NotepadIcon />
                        </div>
                        <div>
                            <div className="flex items-center justify-between">
                                <span className="text-xs font-medium text-gray-500">{card.label}</span>
                            </div>

                            {loading ? (
                                <div className="mt-3 h-6 w-24 animate-pulse rounded bg-gray-100" />
                            ) : (
                                <div className="mt-2 text-xl font-semibold text-gray-900">
                                    {card.isCount ? (value ?? "-") : 'Rp ' + money(value)}
                                </div>
                            )}

                            {!loading && growth != null && (
                                <div className={`mt-1 text-xs font-medium ${isPositive ? "text-emerald-600" : "text-red-500"}`}>
                                    {isPositive ? "▲" : "▼"} {Math.abs(growth)}
                                </div>
                            )}

                            {data?.comparisonLabel && !loading && (
                                <div className="mt-1 text-[11px] text-gray-400">{data.comparisonLabel}</div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}